import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';

import NoOrganizations from '../containers/noOrganizations/NoOrganizations';
import OrganizationHeader from '../containers/header/OrganizationHeader';

import * as organizationSelectors from '../selectors/organizationSelectors';
import routes from '../helpers/ApplicationRoutes';

const LandingPage = ({ organizations }) => {
    // If the user is on the Landing page, and organizations exist
    // redirect to the first
    if (organizations && organizations.length) {
        return (
            <Redirect
                to={routes.organization.getPath({
                    organizationId: organizations[0].id,
                })}
            />
        );
    }

    return (
        <React.Fragment>
            <OrganizationHeader />
            <NoOrganizations />
        </React.Fragment>
    );
};

const mapStateToProps = state => ({
    organizations: organizationSelectors.getOrganizations(state),
});

export default connect(mapStateToProps)(LandingPage);



// WEBPACK FOOTER //
// ./src/pages/LandingPage.js